import React, {useState} from 'react'

const AddDialog = ({setShowAch, setLoading, setResponse}) => {
        // const [showAch, setShowAch] = useState(false);
  const [formData, setFormData] = useState({
    tagline: '',
    description: '',
    image: null,
    status: 'Unapproved',
    added_by: '',
    category: 'All',
    batch: ''
  })
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = new FormData();
    payload.append('tagline', formData.tagline);
    payload.append('description', formData.description);
    payload.append('image', formData.image);
    payload.append('status', formData.status || 'Unapproved');
    payload.append('added_by', formData.added_by);
    payload.append('category', 'All');
    payload.append('batch', formData.batch);
  
    setLoading(true);
  
    try {
      const response = await fetch('https://api.kcian.in/add-achievement', {
        method: 'POST',
        body: payload,
      });
  
      if (response.ok) {
          setLoading(false);
        setShowAch(false);
        setFormData({ tagline: '', description: '', image: null, status: 'Unapproved' });
         setResponse({ message: 'Achievement submitted! Wait for Approval to display on Website.', status: 'success' });
        setTimeout(() => setResponse(''), 3000);
      } else {
          setLoading(false);      
         setResponse({ message: 'Something went wrong. Try again later.', status: 'error' });
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error("Error submitting achievement:", error);
          setLoading(false);
    }
  };
  

  
  return (
    <>
          <section className='dialog-outer'>
      <div className='dialog-inner col-lg-6 mx-auto py-4'>

        <p className='page-heading text-center'>Add Achievement</p>
        {/* <hr /> */}

        <form onSubmit={handleSubmit}>

          <div className='mb-3'>
            <label className='login-label'>Your Name*</label>
            <input
              type='text'
              name='added_by'
              value={formData.added_by}
              onChange={handleChange}
              className='login-control'
              required
            />          </div>

          <div className='mb-3'>
            <label className='login-label'>Tagline*</label>
            <input
              type='text'
              name='tagline'
              value={formData.tagline}
              onChange={handleChange}
              className='login-control'
              required
            />
          </div>

                    <div className='mb-3'>
            <label className='login-label'>Your Batch</label>
            <input
              type='text'
              name='batch'
              value={formData.batch}
              placeholder='2024-25'
              onChange={handleChange}
              className='login-control'
            />
          </div>

          <div className='mb-3'>
            <label className='login-label'>Description*</label>
            <textarea
              name='description'
              value={formData.description}
              onChange={handleChange}
              rows='4'
              className='login-control'
              required
            ></textarea>
          </div>

          <div className='mb-3'>
            <label className='login-label'>Upload Image*</label>
            <input
              type='file'
              accept='image/*'
              onChange={handleImageChange}
              className='login-control'
              required
            />
          </div>

<input type="hidden" name="status" value={formData.status} />

          {formData.image && (
            <div className='mb-3'>
              {/* <label className='login-label'>Image Preview:</label><br /> */}
              <img
                src={URL.createObjectURL(formData.image)}
                alt='Preview'
                className='img-fluid rounded border'
                style={{ maxHeight: '160px' }}
              />
            </div>
          )}

                  <button type='submit' className='notice-btn2 me-2'>
                    Submit
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowAch(false)}>
                    Cancel
                  </button>

          {/* <div className='d-flex justify-content-between mt-4'>
            <button type='submit' className='btn btn-success'>Submit</button>
            <button type='button' className='btn btn-secondary' onClick={() => setShowAch(false)}>Cancel</button>
          </div> */}

        </form>

      </div>
    </section>
    </>
  )
}

export default AddDialog
